export default {
  editButtonLabel: 'Edit',
  deleteButtonLabel: 'Delete',
  noTemplatesMessage: 'No templates found.'
};
